import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      class="design-iconfont"
    >
      <path
        fill={color}
        d="M9.5,13 L9.5,12 L6.5,12 L6.5,13 L9.5,13 Z M4.5,1.5 L11.5,1.5 C12.0522852,1.5 12.5,1.94771528 12.5,2.5 L12.5,14 C12.5,14.5522842 12.0522852,15 11.5,15 L4.5,15 C3.94771522,15 3.5,14.5522852 3.5,14 L3.5,2.5 C3.5,1.94771546 3.94771528,1.5 4.5,1.5 Z M11.5,2.5 L11.5,14 L4.5,14 L4.5,2.5 L11.5,2.5 Z"
        fill-opacity=".80999998"
        fill-rule="evenodd"
      />
    </svg>
  )
}

const LoginMobileIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default LoginMobileIcon
